import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-replay',
  templateUrl: './button-replay.component.html',
  styleUrls: ['./button-replay.component.less']
})
export class ButtonReplayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
